<br>
<div *ngIf="enableLoader" id="loader"></div>
<div class="text-center strong  text-primary mb-5" *ngIf="showNotAvailableMsg">{{'common.noData' | cxTranslate}}</div>
<div *ngIf="portsList && grid && !showNotAvailableMsg && !enableLoader">
  <div class="search-results" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
    (scrolled)="onScrollGrid()" [scrollWindow]="true">
    <div *ngFor="let item of portsList,let i = index">
      <app-custom-product-carousel [item]=item [index]=index [browseType]=browseType></app-custom-product-carousel>
    </div>
  </div>
  <div *ngIf="loaderShow" id="loader"></div>
</div>

<div class="container">
  <div *ngIf="portsList && list && !showNotAvailableMsg && !enableLoader">
    <div class="search-results" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
    (scrolled)="onScroll()" [scrollWindow]="true">
    <div *ngFor="let item of portsList,let i = index">
      <app-products-list-view [item]=item [index]=index [browseType]=browseType></app-products-list-view>
    </div>
    </div>
    <div *ngIf="loaderShow" id="loader"></div>
  </div>
</div>
